<template>
  <div class="mainContent">
    <QA :loading.sync="loading" :qidList="qidList" :wChange="true" :isEnd="isEnd" :isInnovation="true" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer" ></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue'
import { answerUpload } from '@/services/exam'
export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        title: '题目1',
        small: [
          {
            id: 1,
            title: '(1)',
            desc: [
              '（1）请在5分钟内，<span class="title_span">尽可能多</span>地列举可以使用遥控器控制的某物品功能。',
              '例如：切换电视频道、改变空调温度……',
            ],
            durationTime: 5,
            stemContent: [
              {
                type: 'text',
                value: '这是电视的遥控器，可以远距离控制电视的各种功能。最早的电视遥控器是有线的，后来出现了利用超声波和红外线控制电视频道的遥控器。现在的电视遥控器功能非常丰富，遥控器的设计和使用为人们提供各种便利。'
              },
              {
                type: 'img',
                value: require('./../../../../assets/exam/33.png')
              },
              {
                type: 'text',
                value: '<b>题目1：</b>在生活中，很多物品的功能都能用遥控器来控制。'
              }
            ],
            // showAnswer: false,
            askList: [{
              id: 1,
              type: 4,
              config: {
                noneInput: true,
              },
              title: '* 确认的文字不能修改，作答时间 5 分钟。'
            }]
          },
          {
            id: 2,
            title: '(2)',
            desc: ['（2）请将你想到的物品及功能按类别拖拽到相应的分类框里，如果你想到的物品及功能超出列出的这几类，可以点击“+”添加新的分类框。除了已经想到的这些，你能再提出一些新的需要使用遥控器的物品及功能吗？请将新想法添加到相应的分类框里。'],
            durationTime: 3,
            stemContent: [
              // {
              //   type: 'text',
              //   value: '请将你已经写出的答案进行分类，与已有分类一致的，请将答案用鼠标拖拽进对应图形中。如果需要增加新的分类，请你在空白图形上输入分类名称，然后再把对应答案放入图形中。'
              // },
              {
                type: 'text',
                value: '你的作答：'
              },
              {
                type: 'array'
              },
            ],
            askList: [{
              id: 1,
              type: 8,
              typeList: [
                {
                  title: '家用电器',
                  disabled: true,
                  children: []
                },
                {
                  title: '玩具',
                  disabled: true,
                  children: []
                }
              ]
            }]
          }
        ]
      }, {
        qid: 2,
        title: '题目2',
        small: [
          {
            id: 3,
            title: '(3)',
            desc: ['（3）请发挥你的想象力，为电视遥控器设计1个新的供电方式，该方式是<span class="title_span">其他同学不容易想到的</span>，请用文字或画图的方式，清晰、具体地表达出你的想法。'],
            durationTime: 7,
            stemContent: [
              {
                type: 'text',
                value: '<b>题目2：</b>设计遥控器的供电方式'
              },
              {
                type: 'text',
                value: '电视遥控器要使用普通电池作为电源。由于遥控器每次只是按下按键的时候才会消耗一点电量，所以电池要用很久才会更换一次。这样长时间的放置，电池也会自动放电，白白消耗了电量造成浪费。'
              },
            ],
            askList: [{
              id: 1,
              type: 1,
              isReview: true,
              noneInput: true,
              // title: '(3)请使用电子绘图区作答，用文字和画图的方式，清晰、准确地表达你的设计想法。'
            },
            {
              id: 2,
              type: 10,
              // title: '如果需要，可采用设计图呈现你的想法。可画在下发的答题纸上。'
            }]
          },
          {
            id: 4,
            title: '(4)',
            desc: ['（4）你是受到什么启发或有什么依据提出的这个设计创意的？'],
            durationTime: 2,
            stemContent: [
              {
                type: 'text',
                value: '新的供电方式：'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'text',
                value: '设计图：'
              },
              {
                type: 'draw',
                value: 'img'
              }
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              title: ''
            }]
          }
        ]
      }, {
        qid: 3,
        title: '题目3',
        small: [
          {
            id: 5,
            title: '(5)',
            durationTime: 5,
            desc: ['（5）请你评价李明这个设计创意的优点和不足，写出具体的理由。'],
            stemContent: [
              {
                type: 'text',
                value: '<b>题目3：</b>奶奶的遥控器'
              },
              {
                type: 'text',
                value: '李明的奶奶喜欢看电视，但自从换了新的智能电视就遇到了困难。虽然现在的电视遥控器按键不多，但都需要看着电视上的各个选项、菜单来选择内容，这让奶奶实在搞不明白。于是李明想设计一个新的电视遥控器，让奶奶使用遥控器快捷地找到要看的电视内容。'
              },
              {
                type: 'text',
                value: '李明的设计有几个特点，遥控器的按键能够拆卸；每个按键都能独立设定功能；所有按键都能进行随意组合。'
              },
              {
                type: 'img',
                showBigImg: true,
                value: require('@/assets/exam/c5control.gif')
              },
            ],
            askList: [{
              id: 1,
              type: 1,
              noneInput: true,
              isReview: true
            }]
          },
          {
            id: 6,
            title: '(6)',
            durationTime: 10,
            desc: ['（6）请用文字或设计草图的方式，清晰、具体地表达出你的改进建议。'],
            stemContent: [
              {
                type: 'text',
                value: '你认为李明为奶奶设计的遥控器还有哪些不足或需要改进的地方，请提出改进建议，让遥控器更加适合奶奶使用。'
              },
              {
                type: 'text',
                value: '你对李明创意的评价：'
              },
              {
                type: 'text',
                value: ''
              },
              {
                type: 'img',
                showBigImg: true,
                value: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_628f71f4577c0/101873727.png'
                // value: require('@/assets/exam/49.png')
              },
            ],
            // askList: [{
            //   id: 1,
            //   type: 7
            // }]
            askList: [
              {
                id: 2,
                type: 1,
                noneInput: true,
                title: ''
              },
              {
                id: 1,
                type: 9,
                customList: [
                  { left: 0, top: 0, title: '' }
                ],
                title: '可以拖拽、增减按钮；改变按钮位置、大小、形状；添加文字说明。',
                style: 'color:#000000;text-indent: 2em'
              },
            ]
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    };
  },
  methods: {
    getSmallList() {
      const list = this.qidList.reduce((list, item) => {
        list.push(...item.small)
        return list
      }, [])
      return list
    },
    getAnswer(obj) {
      const selectedQidSmall = obj.selectedQidSmall
      const smallList = this.getSmallList()
      const smallItem = smallList[selectedQidSmall]
      for (const item of smallItem.stemContent) {
        if (item.type == 'text' && item.value == '') {
          item.value = obj.text
        }
      }
      // this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const num = currentQSmall % 2 === 1 ? 1 : 2
      const tab = Math.floor(currentQSmall / 2)
      const data = Object.assign({
        exam_id: 1,
        exam_num: (num === 1 ? tab + 1 : tab) + '_' + num,
        subject_id: 3,
        subject_name: '遥控器',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'innovationSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
  mounted () {
    // if (sessionStorage.selectedQidSmall) {
    //   const obj = JSON.parse(sessionStorage.selectedQidSmall)
    //   if (obj.controller && Number(obj.controller) > 1) {
    //     this.selectedQidSmall = Number(obj.controller)
    //   } else {
    //     this.selectedQidSmall = 1
    //   }
    // } else {
    //   this.selectedQidSmall = 1
    // }
  }
}
</script>

<style lang="less" scoped>
.mainContent {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 45%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_630d74fa7595a/477599893.png);
    background-size: 100% 100%;
    padding: 4% 2%;
    overflow-y: auto;
    .headline {
      font-size: 18px;
      color: #ffffff;
      line-height: 22px;
      width: 100%;
      text-align: center;
      padding-bottom: 50px;
      position: relative;
    }
    .headline::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 31px;
      margin-left: -18px;
      width: 35px;
      height: 3px;
      background: #ffffff;
      border-radius: 2px;
    }
    .content {
      width: 100%;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 0px 11px -5px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      .tab {
        width: 100%;
        height: 47px;
        background: #fafafa;
        border-radius: 6px 6px 0px 0px;
        border: 1px solid #ebebeb;
        display: flex;
        align-items: center;
        > div {
          padding-right: 54px;
          font-size: 14px;
          font-weight: 400;
          color: #7c8288;
          line-height: 20px;
        }
        > div:nth-child(1) {
          padding-left: 42px;
        }
        .active {
          color: #0794f1;
        }
      }
      .issue {
        padding: 41px 33px;
        .num {
          font-weight: 400;
          color: #252f38;
          line-height: 27px;
          margin-bottom: 27px;
          span {
            font-size: 16px;
          }
          span:nth-child(2) {
            padding: 0 4px;
          }
          span:nth-child(1) {
            color: #0794f1;
            font-size: 24px;
          }
        }
        .list {
          font-size: 16px;
          font-weight: 400;
          color: #252f38;
          line-height: 27px;
          margin: 27px 0;
          img {
            width: 90%;
            margin: 0 auto;
            display: block;
          }
        }
      }
    }
  }
  .right {
    width: 55%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_630d76adb1424/360215309.png);
    background-size: 100% 100%;
    padding: 0 28px;
    box-sizing: border-box;
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #2144ff;
      line-height: 25px;
      margin-bottom: 44px;
    }
    .submitList {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666d73;
        line-height: 17px;
      }
      > div {
        width: 75px;
        height: 33px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #39ab8f;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 9px;
        font-weight: 400;
        color: #39ab8f;
        line-height: 9px;
        margin-right: 4px;
      }
    }
    .title {
      margin-top: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-top: 12px;
    }
    .tip {
      padding-top: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #666d73;
      line-height: 22px;
    }
    .record {
      width: 100%;
      height: 238px;
      background: #f8f8f8;
      border: 1px solid #efefef;
      padding: 24px;
      position: relative;
      margin-top: 12px;
      > textarea {
        font-size: 16px;
        font-weight: 400;
        color: #383838;
        line-height: 26px;
        width: 100%;
        height: 130px;
        outline: none;
        border: 1px solid #eee;
        padding: 10px;
      }
      .collect {
        position: absolute;
        left: 24px;
        bottom: 24px;
        width: 127px;
        height: 33px;
        background: #4594fb;
        box-shadow: 0px 5px 6px -4px rgba(41, 54, 242, 0.31),
          inset 0px 3px 8px 0px rgba(255, 255, 255, 0.48);
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
        }
        > img {
          width: 24px;
          margin-right: 4px;
        }
      }
      .submit {
        cursor: pointer;
        position: absolute;
        right: 24px;
        bottom: 24px;
        width: 119px;
        height: 33px;
        background: #ffffff;
        box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        border: 1px solid #d9dadc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 6px;
      border: 1px solid #4594fb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #4594fb;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
  }
}
/deep/ .remote-control {
  padding-top: 1rem;
  .title {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 16px;
  }
}
</style>
